import { createSelector } from 'reselect';

const getGeneralFilter = ({ overview }) => {
    return overview?.assets?.data;
};

const getSelectedOrganization = ({ generalFilter }) => {
    return generalFilter?.selectedFilters?.organizations[0];
};

export const getModel = createSelector(
    [
        getGeneralFilter,
        getSelectedOrganization
    ],
    (
        generalFilter,
        selectedOrganization
    ) => {
        return {
            generalFilter,
            selectedOrganization
        };
    }
);
